<script setup>
import "@sapudex/web-components/dist/MessageStrip.js";
import "@sapudex/web-components/dist/Tag.js";

</script>

<template>
  <div class="m-auto max-w-3xl">
    <div class="body-xs-size text-center my-6">
      <udex-tag
        id="udex-tag"
        :text="$t('editor.keyword.description.short')"
        design="Grey"
        icon="hide"
        icon-placement="Start"
        size="Medium"
        desktop
        accessible-role="note"
        non-selectable
      />
    </div>
    <udex-message-strip design="Information" status-type="Icon" hide-close-button>
      <span class="align-middle body-s-size">{{ $t('editor.keyword.message.strip') }}</span>
    </udex-message-strip>
  </div>
</template>
